import { Component, Inject, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HomeService } from './home.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  role: string = '';
  byPass: boolean;
  token: string;
  homeInfo = null;
  isTA: boolean;

  teacherList = [{
    title: 'บทความ',
    link: 'article-management',
    imgUrl: '../assets/icons/blog.png'
  }, {
    title: 'ตารางกิจกรรม',
    link: 'activity-management',
    imgUrl: '../assets/icons/desktop-calendar.png'
  }, {
    title: 'คอร์สเรียน',
    link: 'e-learning-management',
    imgUrl: '../assets/icons/ebook.png'
  }, {
    title: 'แบบทดสอบ',
    link: 'measure-management',
    imgUrl: '../assets/icons/checklist.png'
  }, {
    title: 'รายงานผลแบบทดสอบ',
    link: 'report-management',
    imgUrl: '../assets/icons/score.png'
  }, {
    title: 'วิจัย',
    link: 'research-management',
    imgUrl: '../assets/icons/audience.png'
  }, {
    title: 'Payment',
    link: 'financial-list',
    imgUrl: '../assets/category-icons/payment.png'
  }, {
    title: 'Skill Tree',
    link: 'skill-tree-management',
    imgUrl: '../assets/category-icons/skill-tree.png'
  }];

  adminList1 = [
    [
      {
        title: 'จัดการสมาชิก',
        link: 'user-management',
        imgUrl: '../assets/icons/businessman.png'
      }, {
        title: 'ข่าว',
        link: 'news-management',
        imgUrl: '../assets/icons/newspaper.png'
      }, {
        title: 'บทความ',
        link: 'article-management',
        imgUrl: '../assets/icons/blog.png'
      }, {
        title: 'คอร์สเรียน',
        link: 'e-learning-management',
        imgUrl: '../assets/icons/ebook.png'
      }
    ],
    [
      {
        title: 'ตารางกิจกรรม',
        link: 'activity-management',
        imgUrl: '../assets/icons/desktop-calendar.png'
      }, {
        title: 'แบบทดสอบ',
        link: 'measure-management',
        imgUrl: '../assets/icons/checklist.png'
      }, {
        title: 'รายงานผลแบบทดสอบ',
        link: 'report-management',
        imgUrl: '../assets/icons/score.png'
      }, {
        title: 'วิจัย',
        link: 'research-management',
        imgUrl: '../assets/icons/audience.png'
      }
    ]
  ]

  adminList2 = [
    [
      {
        title: 'Payment',
        link: 'payment-management',
        imgUrl: '../assets/category-icons/payment.png'
      }, {
        title: 'Dashboard',
        link: 'dashboard',
        imgUrl: '../assets/category-icons/dashboard.png'
      }, {
        title: 'Skill Tree',
        link: 'skill-tree-management',
        imgUrl: '../assets/category-icons/skill-tree.png'
      }
    ],
    [
      {
        title: 'Accounting',
        link: 'accounting',
        imgUrl: '../assets/category-icons/bill.png'
      },
      {
        title: 'ศูนย์เรียนรู้',
        link: 'learning-center-management',
        imgUrl: '../assets/category-icons/learning.png'
      },
    ]
  ];

  psychologistList = [{
    title: 'บทความ',
    link: 'article-management',
    imgUrl: '../assets/icons/blog.png'
  }, {
    title: 'ตารางกิจกรรม',
    link: 'activity-management',
    imgUrl: '../assets/icons/desktop-calendar.png'
  }, {
    title: 'Payment',
    link: 'financial-list',
    imgUrl: '../assets/category-icons/payment.png'
  }];

  TAList = [{
    title: 'คอร์สเรียน',
    // link: 'e-learning',
    link: 'e-learning-management-ta',
    imgUrl: '../assets/icons/ebook.png'
  }];

  newsMock = {
    ADMIN_CREATID: '',
    NEWS_CATEGORY: '',
    NEWS_END: '',
    NEWS_READED: '',
    NEWS_START: '',
    NEWS_STATUS: '',
    NEWS_ID: null,
    NEWS_TITAL: '',
    NEWS_PIC: 'https://media.istockphoto.com/vectors/geometric-banner-megaphone-with-coming-soon-bubble-loudspeaker-modern-vector-id1181378326?k=6&m=1181378326&s=612x612&w=0&h=G9QQjvLpHdFmKtHkaRbt08NnGgiDbtxZyR5L629Bck0=',
    NEWS_DETAIL: '',
    NEWS_DATE: ''
  }

  courseMock = {
    COURSE_COIN_CLOSE: '',
    COURSE_COIN_REWARD: '',
    COURSE_CREATE: '',
    COURSE_DESCRIPTION: '',
    COURSE_END: '',
    COURSE_ID: '',
    COURSE_NAME: '',
    COURSE_PIC: 'https://media.istockphoto.com/vectors/geometric-banner-megaphone-with-coming-soon-bubble-loudspeaker-modern-vector-id1181378326?k=6&m=1181378326&s=612x612&w=0&h=G9QQjvLpHdFmKtHkaRbt08NnGgiDbtxZyR5L629Bck0=',
    COURSE_PRICE: '',
    COURSE_RECOMMEND: '',
    COURSE_SPECIALPRICE: '',
    COURSE_START: '',
    COURSE_STATUS: '',
    COURSE_TYPE: '',
    COURSE_VDO: '',
    TEACHER_ID: ''
  }

  articalMock = {
    ARTICAL_CATEGORY: '',
    ARTICAL_CREATID: '',
    ARTICAL_DATE: '',
    ARTICAL_DETAIL: '',
    ARTICAL_END: '',
    ARTICAL_ID: '',
    ARTICAL_PIC: 'https://media.istockphoto.com/vectors/geometric-banner-megaphone-with-coming-soon-bubble-loudspeaker-modern-vector-id1181378326?k=6&m=1181378326&s=612x612&w=0&h=G9QQjvLpHdFmKtHkaRbt08NnGgiDbtxZyR5L629Bck0=',
    ARTICAL_READED: '',
    ARTICAL_START: '',
    ARTICAL_STATUS: '',
    ARTICAL_TITAL: ''
  }

  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    margin: 15,
    autoplay: false,
    dots: true,
    navSpeed: 700,
    nav: false,
    // navText: ['<div class='nav-btn prev-slide'></div>', '<div class='nav-btn next-slide'></div>'],
    // navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      760: {
        items: 3
      },
      1000: {
        items: 4
      }
    }
  }

  homeAdminOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    autoplay: false,
    dots: true,
    margin: 15,
    navSpeed: 700,
    responsive: {
      0: {
        items: 4
      },
      400: {
        items: 4
      },
      760: {
        items: 4
      },
      1000: {
        items: 4
      }
    }
  }

  constructor(
    private homeService: HomeService,
    private authService: AuthService,
    private gobalFunctionService: GobalFunctionService
  ) {
    this.authService.token.subscribe(res => this.token = res);
  }

  ngOnInit(): void {
    if (this.token !== '') {
      this.homeService.getRole().subscribe(res => {
        // console.log(res)
        this.role = res.result.ROLE;
        // this.isTA = true;
        this.isTA = res.result.IS_TA;

        if (res.result.ROLE === 'teacher' && res.result.ROLE === 'admin' && res.result.ROLE === 'psychologist') {
          this.byPass = false;
        } else if (res.result.ROLE === 'user' && res.result.IS_TA) {
          // } else if (res.result.ROLE === 'user' && this.isTA){
          this.byPass = false;
        }
      })
    }


    this.homeService.getHome().subscribe(val => {
      let news = [];
      let artical = [];
      let course = [];

      // // console.log(val.result);

      // กรณีข้อมูลยังไม่ครบ 4 ช่อง
      if (val.result.news.length < 4) {
        for (let i = 0; i < 4; i++) {
          news[i] = [];
          if (val.result.news.length > i) {
            news[i] = val.result.news[i];
          } else {
            news[i] = this.newsMock;
          }
        }
      } else {
        news = val.result.news;
      }

      if (val.result.artical.length < 4) {
        for (let i = 0; i < 4; i++) {
          artical[i] = [];
          if (val.result.artical.length > i) {
            artical[i] = val.result.artical[i];
          } else {
            artical[i] = this.articalMock;
          }
        }
      } else {
        artical = val.result.artical;
      }

      if (val.result.course.length < 4) {
        for (let i = 0; i < 4; i++) {
          course[i] = [];
          if (val.result.course.length > i) {
            course[i] = val.result.course[i];
          } else {
            course[i] = this.courseMock;
          }
        }
      } else {
        course = val.result.course;
      }

      this.homeInfo = {
        IS_PREMIUM: val.result.IS_PREMIUM,
        banner: val.result.banner,
        news,
        artical,
        course
      };
    });

    this.gobalFunctionService.setSEO('ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย เพื่อสร้างความรู้-ความเข้าใจด้านจิตวิทยาพัฒนาการแก่สังคมไทย | คอร์สเรียน, กิจกรรม workshop, การให้คำปรึกษา, แบททดสอบทางจิตวิทยา และ ข่าวสาร บทความทางจิตวิทยาที่น่าสนใจ', 'website', '');
  }

  clickByPass() {
    this.byPass = !this.byPass;
  }
}
